module.exports = __webpack_public_path__ + "img/coinDefaultIcon.835879b.png";